/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".crop[_ngcontent-%COMP%]{height:150px;width:150px;overflow:hidden}.crop[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:250px;max-height:150px;width:auto;height:auto;box-sizing:border-box}.box[_ngcontent-%COMP%]{transition:box-shadow .3s;width:280px;height:auto;border:1px solid #ccc;background:#fff}.box[_ngcontent-%COMP%]:hover{box-shadow:0 0 11px rgba(33,33,33,.2)}.cropQR[_ngcontent-%COMP%]{height:150px;width:150px;overflow:hidden}.image-qr[_ngcontent-%COMP%]{margin-left:-9%;cursor:pointer;display:grid;grid-template-columns:1fr 1fr}"];
export { styles as styles };
